import { BooleanValueProperty } from './properties/boolean-property.model';
import { ImageProperty } from './properties/image-property.model';
import { TextProperty } from './properties/text-property.model';
import { Widget } from './form-widget.model';

export class FbImageWidget extends Widget {
  public override title = 'Image';
  public override name = 'fb-image';

  constructor(data: any = {}) {
    super(data);
    this.properties = this.defaultProperties(data.properties);
  }

  defaultProperties(props: any = {}) {
    const properties = {
      text: new TextProperty({ value: props.text ? props.text.value : 'Label 1' }),
      content: new TextProperty(props.content || { title: 'Description' }),
      value: new ImageProperty({
        ...props.value,
        value: props.value.value || 'assets/images/form-editor/defaults/fb-image.png',
      }),
      hideLabel: new BooleanValueProperty({
        value: props.hideLabel ? props.hideLabel.value : false,
      }),
    };
    return properties;
  }
}
